import StationMeteoDataTableController from './meteo-data-table.controller';

const template = require<string>('./meteo-data-table.html');

export default {
  controller: StationMeteoDataTableController,
  bindings: {
  	type: '<'
  },
  template
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/historic-norm/meteoDataTable/meteo-data-table.component.ts
 **/